<p-button
  label="Next song"
  [raised]="true"
  severity="secondary"
  (onClick)="playNext()" />

<p-button
  label="Previous song"
  [raised]="true"
  severity="secondary"
  (onClick)="playPrevious()" />

  <p-button
  label="Select song"
  [raised]="true"
  severity="secondary"
  (onClick)="selectSong()" />

<navigator></navigator>
